export default function Hero() {
  return (
    <section className="relative isolate overflow-hidden pt-32 pb-24 sm:pt-40 sm:pb-32">
      {/* Background grid */}
      <div className="absolute inset-0 -z-10 bg-grid-pattern" />

      {/* Radial gradient blob — Huskly purple */}
      <div className="absolute inset-0 -z-10 flex items-center justify-center">
        <div className="h-[600px] w-[900px] rounded-full bg-huskly-purple/10 blur-[140px]" />
      </div>

      <div className="mx-auto max-w-7xl px-6 lg:px-8">
        <div className="mx-auto max-w-3xl text-center">
          {/* Badge */}
          <div className="mb-8 inline-flex items-center gap-2 rounded-full border border-huskly-teal/20 bg-navy-800/60 px-4 py-1.5">
            <span className="h-1.5 w-1.5 rounded-full bg-huskly-green animate-pulse" />
            <span className="text-xs font-medium tracking-widest text-huskly-teal uppercase">
              Volatility Intelligence System
            </span>
          </div>

          {/* Headline */}
          <h1 className="text-5xl sm:text-6xl lg:text-7xl font-bold tracking-tight leading-none">
            <span className="text-white">News-Aware</span>
            <br />
            <span className="text-gradient">Volatility Intelligence</span>
            <br />
            <span className="text-white">for Equity Options</span>
          </h1>

          <p className="mt-8 text-lg text-slate-400 leading-relaxed max-w-2xl mx-auto">
            Aegis Vol ingests corporate news, SEC filings, and IR releases —
            clustering events, scoring their market impact, and routing them to
            deterministic volatility playbooks so you focus only on trades worth
            taking.
          </p>

          <div className="mt-10 flex flex-col sm:flex-row items-center justify-center gap-4">
            <a
              href="#contact"
              className="w-full sm:w-auto rounded-full bg-huskly-green px-8 py-3.5 text-sm font-bold text-navy-950 hover:bg-huskly-green-light transition-colors"
            >
              Request Early Access
            </a>
            <a
              href="#pipeline"
              className="w-full sm:w-auto rounded-full border border-navy-600 px-8 py-3.5 text-sm font-semibold text-slate-300 hover:border-huskly-teal/50 hover:text-white transition-colors"
            >
              See How It Works →
            </a>
          </div>
        </div>

        {/* Terminal preview */}
        <div className="mt-20 mx-auto max-w-4xl rounded-xl border border-navy-700 bg-navy-800/60 overflow-hidden shadow-2xl">
          {/* Terminal bar */}
          <div className="flex items-center gap-2 border-b border-navy-700 bg-navy-900 px-4 py-3">
            <div className="h-3 w-3 rounded-full bg-red-500/70" />
            <div className="h-3 w-3 rounded-full bg-yellow-500/70" />
            <div className="h-3 w-3 rounded-full bg-green-500/70" />
            <span className="ml-2 text-xs text-slate-500 font-mono">
              aegis-vol — decision log
            </span>
          </div>
          {/* Terminal content */}
          <div className="p-6 font-mono text-sm space-y-3">
            <div className="text-slate-500">
              <span className="text-slate-600">12:04:18</span> [INGEST]{" "}
              <span className="text-slate-300">
                SEC 8-K filed — ACME Corp — Material Agreement Amendment
              </span>
            </div>
            <div className="text-slate-500">
              <span className="text-slate-600">12:04:19</span> [NORMALIZE]{" "}
              <span className="text-slate-300">
                ticker=ACME source_tier=1 credibility=0.91
              </span>
            </div>
            <div className="text-slate-500">
              <span className="text-slate-600">12:04:19</span> [SCORE]{" "}
              <span className="text-yellow-400">priority=ANALYZE</span>{" "}
              <span className="text-slate-400">
                credibility=0.88 novelty=0.94 impact=0.81
              </span>
            </div>
            <div className="text-slate-500">
              <span className="text-slate-600">12:04:20</span> [LLM]{" "}
              <span className="text-slate-300">
                directionality=two_sided vol_risk=high playbook=LONG_GAMMA
              </span>
            </div>
            <div className="text-slate-500">
              <span className="text-slate-600">12:04:20</span> [ROUTE]{" "}
              <span className="text-huskly-teal font-semibold">
                → LONG_GAMMA
              </span>
            </div>
            <div className="text-slate-500">
              <span className="text-slate-600">12:04:21</span> [INTENT]{" "}
              <span className="text-huskly-green">
                ATM straddle · front expiry · max debit 2.5%
              </span>
            </div>
            <div className="flex items-center gap-2 mt-2">
              <span className="text-huskly-teal">▸</span>
              <span className="text-slate-500 text-xs italic">
                All decisions logged. Fully auditable. Reproducible.
              </span>
            </div>
          </div>
        </div>
      </div>
    </section>
  );
}
